<template>
  <div style="width:206px;" v-if="leftMenuListForDev.length>0">
    <el-menu
      default-active="1-4-1"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      :router="elLeftMenu.router"
      :unique-opened="elLeftMenu.uniqueOpened"
      :collapse-transition="elLeftMenu.collapseTransition"
      background-color="#252a2f"
      text-color="#ffffff"
    >
      <div v-for="item in leftMenuListForDev" :key="item.id">
        <el-menu-item :route="item.url" :index="item.id.toString()" v-if="item.child.length==0">
          <img class="menu-icon" :src="item.thumb">

          <el-badge
            class="leftmenubadge"
            :value="noticeList.length"
            v-if="item.id==40&&noticeList.length>0"
          ></el-badge>
          <span slot="title">{{item.menuname}}</span>
        </el-menu-item>
        <el-submenu
          :index="item.id.toString()"
          :class="{hidei:isCollapse}"
          :route="item.url"
          v-else
        >
          <template slot="title">
            <img class="menu-icon" :src="item.thumb">
            <span slot="title" v-if="!isCollapse">{{item.menuname}}</span>
          </template>
          <el-menu-item
            v-for="citem in item.child"
            :key="citem.id"
            :route="citem.url"
            :index="citem.id.toString()"
          >
            <img class="menu-icon" :src="citem.thumb">
            <span slot="title">{{citem.menuname}}</span>
          </el-menu-item>
        </el-submenu>
      </div>
      <!-- <el-submenu
        index="5"
        v-for="item in leftMenuListForDev"
        :key="item.id"
        :index="item.id.toString()"
        :route="item.url"
        v-if="item.child.length>0"
      >
        <template slot="title">
          <img class="menu-icon" :src="item.thumb">
          <span slot="title">{{item.name}}</span>
        </template>
        <el-menu-item v-for="citem in item.child" :key="citem.id">
          <img class="menu-icon" :src="citem.thumb">
          <span slot="title">{{citem.name}}</span>
        </el-menu-item>
      </el-submenu>-->
      <!-- <el-menu-item index="2" route="/personnelmatters/depart">
        <img class="menu-icon" src="../../../static/images/personnelmatters-person.png">
        <span slot="title">员工管理</span>
      </el-menu-item>
      <el-menu-item index="3">
        <img class="menu-icon" src="../../../static/images/personnelmatters-honor.png">
        <span slot="title">员工表彰</span>
      </el-menu-item>
      <el-menu-item index="4">
        <img class="menu-icon" src="../../../static/images/personnelmatters-recruit.png">
        <span slot="title">招聘管理</span>
      </el-menu-item>
     
      <el-menu-item index="6">
        <img class="menu-icon" src="../../../static/images/personnelmatters-leave.png">
        <span slot="title">请假审批</span>
      </el-menu-item>
      <el-menu-item index="7">
        <img class="menu-icon" src="../../../static/images/personnelmatters-rules.png">
        <span slot="title">规则制度</span>
      </el-menu-item>-->
    </el-menu>
  </div>
</template>

<script>
export default {
  /**
   * 组件
   */
  components: {},
  props: ["leftMenuListForDev", "isCollapse", "noticeList"],
  /**
   * 数字
   */
  data() {
    return {
      elLeftMenu: {
        isCollapse: false,
        router: true,
        uniqueOpened: true,
        collapseTransition: true
      }
    };
  },
  /**
   * 监听Vue实例上的数据变动
   */
  watch: {},

  /**
   * 方法、函数
   */
  methods: {
    // leftMenuExpends: function() {
    //   this.$emit("leftMenuExpends");
    // }
  },
  /**
   * 完成挂载
   */
  mounted() {},
  /**
   * 更新完成状态
   */
  updated: function() {},
  /**
   * 完成了 data 数据的初始化
   */
  async created() {}
};
</script>
<style>
.el-submenu__title {
  padding-left: 0px !important;
  text-align: center;
  padding: 0;
}
.menu-icon {
  width: 22px;
  height: 22px;
}
/* .el-menu-item > span,
.el-submenu > .el-submenu__title > span {
  padding-left: 5px;
} */
</style>
<style>
.el-submenu__title {
  text-align: left !important;
  padding-left: 20px !important;
}
.hidei .el-submenu__title i {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/leftAsideMenu.vue